/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
$(document).ready(function() {
    $('ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });

  //console.log('getUrlVars');
  	var urlVars=getUrlVars();
 	//console.log(urlVars.referral_code);
    if(urlVars.referral_code=='single'){
     
    setTimeout(function() { 
       $( ".rc_radio__autodeliver" ).prop( "checked", false );
       $(".rc_radio__autodeliver" ).removeAttr("checked");
       $(".rc_radio__onetime" ).prop( "checked", true );
       $(".rc_radio__onetime" ).attr( "checked",true);
       $('.rc_block__type__autodeliver').removeClass('rc_block__type--active');
       $('.rc_block__type__onetime').addClass('rc_block__type--active');
       $('#rc_subscription_id').attr("name","");
       $('#rc_shipping_interval_unit_type').attr("name","");
       $('#rc_duplicate_selector').attr("name","");
      
       $('.product-form__master-select').attr("name","id");
                               
        }, 1);  
    }
  
  });

function getUrlVars()
{
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
   for(var i = 0; i < hashes.length; i++)
    {
       hash = hashes[i].split('=');
       vars.push(hash[0]);
       vars[hash[0]] = hash[1];
   }
   return vars;
}
